import { useEffect } from 'react';
import { useNavbar } from '@app/atoms/app/navbar.atom.ts';
import {
  Tabs,
  Tab,
  Accordion,
  AccordionItem,
  Input,
  Breadcrumbs,
  BreadcrumbItem,
} from '@heroui/react';
import { SelfPickup } from '../../entites/checkout/self-pickup';
import { CourierDelivery } from '../../entites/checkout/courier-delivery';
import { CartList, CartSubmit, CartSum } from '@ui/cart';
import { useCart } from '@features/cart';
import { PaymentTypes } from '@ui/checkout/payment-types';
import { CheckoutFooter } from '../../entites/checkout';
import { useCheckout } from '@features/checkout';
import { Home2 } from 'iconsax-react';

export const CheckoutPage = () => {
  const set = useNavbar();
  const cart = useCart();
  const checkout = useCheckout();

  useEffect(() => {
    set.checkout();
  }, []);
  return (
    <>
      <div className="hidden lg:block container max-w-7xl lg:mx-auto">
        <div className="hidden lg:block mt-12">
          <Breadcrumbs>
            <BreadcrumbItem href="/">
              <Home2 size="24" color="#9CA5AC" />
            </BreadcrumbItem>
            <BreadcrumbItem href="/cart">Корзина</BreadcrumbItem>
            <BreadcrumbItem color="primary">Оформление заказа</BreadcrumbItem>
          </Breadcrumbs>
        </div>

        <div className="mt-6">
          <h1 className="hidden lg:inline text-4xl text-[#222222] font-bold">
            Оформление заказа
          </h1>
        </div>

        <div className="hidden lg:flex flex-row mt-12 min-h-[460px] container max-w-7xl mx-auto gap-x-[84px] pb-32">
          <div className={`flex-grow max-w-[760px] pb-12`}>
            <div className="p-4 border rounded-xl">
              <Accordion>
                <AccordionItem
                  key="products"
                  title="Товаров в заказе"
                  subtitle={`${cart.checkout.length} товар-(a/ов)`}
                  aria-label="Products in cart"
                  classNames={{
                    title: 'text-[#222223] font-semibold',
                    subtitle: 'text-[#60656C]',
                    content: 'py-0 pb-4',
                  }}
                >
                  <CartList
                    isCompact
                    items={cart.checkout}
                    isShowPlaceholder={false}
                  />
                </AccordionItem>
              </Accordion>
            </div>

            <p className="text-[#222223] pt-4 font-semibold text-base lg:text-[20px]">
              Способ получения
            </p>

            <Tabs
              aria-label="Delivery tabs"
              className="bg-[#F5F5F5] rounded-lg mt-4"
              fullWidth
              size="lg"
              selectedKey={checkout.data.tab}
              onSelectionChange={(key) => {
                if (typeof key === 'string') checkout.data.setTab(key);
              }}
              classNames={{ panel: 'px-0 py-4', tab: 'text-sm text-[#222222]' }}
            >
              <Tab key="pickup" title="Самовывоз">
                <SelfPickup />
              </Tab>

              <Tab key="delivery" title="Доставка" disabled>
                <CourierDelivery />
              </Tab>
            </Tabs>

            <div className="pb-4 flex flex-col gap-y-3">
              <p className="text-[#222223] pt-4 pb-1 font-semibold text-base lg:text-[20px]">
                Покупатель
              </p>

              <Input
                isDisabled
                isRequired
                label="Номер телефона"
                value="+7 (702) 991 72 15"
                size="lg"
                color="success"
              />

              <Input
                label="Имя"
                value={checkout.data.name}
                onValueChange={checkout.data.setName}
                size="lg"
              />
            </div>

            <PaymentTypes
              label="Способ оплаты"
              value={checkout.data.paymentType}
              onChange={checkout.data.setPaymentType}
              items={[
                {
                  value: 'kaspi',
                  title: 'Kaspi Платежи',
                  description: 'Оплата в приложении Kaspi',
                  image: '/kaspi_pay.png',
                },
                {
                  value: 'woopay',
                  title: 'Kaspi Платежи',
                  description: 'Оплата в приложении Kaspi',
                  image: '/woopay_pay.png',
                },
                {
                  value: 'jetpay',
                  title: 'Kaspi Платежи',
                  description: 'Оплата в приложении Kaspi',
                  image: '/jetpay_pay.png',
                },
              ]}
            />
          </div>

          <div className="w-[430px] flex flex-col gap-y-6">
            <div className="pb-6">
              <CartSum
                sum={cart.sum}
                count={cart.productIds.length}
                isLoading={false}
              />
            </div>

            <CartSubmit variant="checkout" onPress={checkout.data.submit} />
          </div>
        </div>
      </div>

      <div className="lg:hidden">
        <div className="-mx-2">
          <Accordion>
            <AccordionItem
              key="products"
              title="Товаров в заказе"
              subtitle={`${cart.checkout.length} товар-(a/ов)`}
              aria-label="Products in cart"
              classNames={{
                title: 'text-[#222223] font-semibold',
                subtitle: 'text-[#60656C]',
                content: 'py-0 pb-4',
              }}
            >
              <CartList
                isCompact
                items={cart.checkout}
                isShowPlaceholder={false}
              />
            </AccordionItem>
          </Accordion>
        </div>

        <div className="bg-[#F8F9FA] h-2 -mx-4" />

        <p className="text-[#222223] pt-4 font-semibold text-base">
          Способ получения
        </p>

        <Tabs
          aria-label="Delivery tabs"
          className="bg-[#F5F5F5] rounded-lg mt-4"
          fullWidth
          size="lg"
          selectedKey={checkout.data.tab}
          onSelectionChange={(key) => {
            if (typeof key === 'string') checkout.data.setTab(key);
          }}
          classNames={{ panel: 'px-0 py-4', tab: 'text-sm text-[#222222]' }}
        >
          <Tab key="pickup" title="Самовывоз">
            <SelfPickup />
          </Tab>

          <Tab key="delivery" title="Доставка" disabled>
            <CourierDelivery />
          </Tab>
        </Tabs>

        <div className="bg-[#F8F9FA] h-2 -mx-4" />

        <div className="pb-4 flex flex-col gap-y-3">
          <p className="text-[#222223] pt-4 pb-1 font-semibold text-base">
            Покупатель
          </p>

          <Input
            isDisabled
            isRequired
            label="Номер телефона"
            value="+7 (702) 991 72 15"
            size="lg"
            color="success"
          />

          <Input
            label="Имя"
            value={checkout.data.name}
            onValueChange={checkout.data.setName}
            size="lg"
          />
        </div>

        <div className="bg-[#F8F9FA] h-2 -mx-4" />

        <PaymentTypes
          label="Способ оплаты"
          value={checkout.data.paymentType}
          onChange={checkout.data.setPaymentType}
          items={[
            {
              value: 'kaspi',
              title: 'Kaspi Платежи',
              description: 'Оплата в приложении Kaspi',
              image: '/kaspi_pay.png',
            },
            {
              value: 'woopay',
              title: 'Kaspi Платежи',
              description: 'Оплата в приложении Kaspi',
              image: '/woopay_pay.png',
            },
            {
              value: 'jetpay',
              title: 'Kaspi Платежи',
              description: 'Оплата в приложении Kaspi',
              image: '/jetpay_pay.png',
            },
          ]}
        />

        <div className="bg-[#F8F9FA] mt-4 h-2 -mx-4" />

        <div className="pt-4 pb-6">
          <CartSum
            sum={cart.sum}
            count={cart.productIds.length}
            isLoading={false}
          />
        </div>

        <CheckoutFooter onPress={checkout.data.submit} />
      </div>
    </>
  );
};
